/* eslint-disable no-console */
import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import dataReducer from '../Reducers/data';
import filtersReducer from '../Reducers/filters';
import filtersDataReducer from '../Reducers/filtersData';
import loadingReducer from '../Reducers/loading';
import errorHandlerReducer from '../Reducers/errorHandler';
import loginHandlerReducer from '../Reducers/loginHandler';
import userInfoReducer from '../Reducers/userInfo';
import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
    const store = createStore(
        combineReducers({
            data             : dataReducer,
            filters          : filtersReducer,
            filtersData      : filtersDataReducer,
            userInfo         : userInfoReducer,
            loadingIndicator : loadingReducer,
            errorHandler     : errorHandlerReducer,
            loginHandler     : loginHandlerReducer
        }),
        composeEnhancers(applyMiddleware(thunk))
    );

    // store.subscribe(() => {
    //     console.log(store.getState());
    // });

    return store;
};



// WEBPACK FOOTER //
// ./src/Store/configureStore.js